import download from "downloadjs";
import { customFetch } from "./CustomFetch";

export const downloadExamResult = (fileName: string) => {
  return customFetch(`examResult/${fileName}`)
    .then((response) => response.blob())
    .then((blob) => {
      download(blob, fileName);
    });
};
